import { title } from "assets/jss/material-dashboard-pro-react.jsx";

const errorPageStyles = theme => ({
  contentCenter: {
    position: "absolute",
    top: "50%",
    left: "50%",
    zIndex: "3",
    transform: "translate(-50%,-50%)",
    textAlign: "center",
    color: "#000",
    padding: "0 15px",
    width: "100%",
    maxWidth: "880px",
    opacity: ".5"
  },
  title: {
    ...title,
    fontSize: "7em",
    color: "#000",
    letterSpacing: "14px",
    fontWeight: "700",
    opacity: ".5"
  },
  subTitle: {
    fontSize: "2rem",
    marginTop: "0",
    marginBottom: "8px"
  },
  description: {
    fontSize: "1rem",
    marginTop: "0",
    marginBottom: "8px"
  }
});

export default errorPageStyles;
